define('components/course/models/slide-type/module-intro',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base.extend({
        "defaults": function () {
            var baseDefaults = Base.prototype.defaults.call(this),
                defaults;

            defaults = {
                "data": {
                    "backgroundImage": null,

                    "content": ""
                }
            };

            return _.extend(baseDefaults, defaults);
        }
    });
});

